import { type PreferenceType } from '@dhl/receiver-preference-api'

export const paths = {
  DETAILS: 'details',
  SETUP: 'setup',
}

export const deliveryPreferenceLinks = {
  deliveryPreferenceDetailsLink: ({ addressId }: { addressId: string }) => `/${paths.DETAILS}/${addressId}`,
  deliveryPreferenceSetupLink: ({ addressId, type }: { addressId: string; type: PreferenceType | '*' }): string =>
    `/${paths.SETUP}/${addressId}/${type}`,
}

export type DeliveryPreferencesLinks = typeof deliveryPreferenceLinks
